// Word fill ([data-word-fill] with data-scroll-progress, the quote block): its headline is split into words, which
// light up one after the other while the block scrolls towards the middle of the window; all are lit once its
// middle is a little above the window's middle. The text itself stays one text for screen readers (the words are
// plain spans).
const START = 0.12 // --progress at which the first word lights up
const END = 0.46 // and the last one

export function initWordFill() {
	document.querySelectorAll('[data-word-fill]').forEach((block) => {
		const heading = block.querySelector('.yn-article__heading .heading')
		if (!heading) return
		const words = splitWords(heading)
		let lit = -1

		block.addEventListener('scrollprogress', ({ detail: progress }) => {
			const count = Math.round(Math.min(1, Math.max(0, (progress - START) / (END - START))) * words.length)
			if (count === lit) return
			lit = count
			words.forEach((word, index) => word.classList.toggle('is-lit', index < count))
		})
	})
}

// wraps every word of the element's text nodes in a span.fill-word, keeping the markup around them (<em>)
function splitWords(element) {
	const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT)
	const nodes = []
	while (walker.nextNode()) nodes.push(walker.currentNode)

	return nodes.flatMap((node) => {
		const fragment = document.createDocumentFragment()
		const words = []
		node.textContent.split(/(\s+)/).forEach((piece) => {
			if (!piece) return
			if (/^\s+$/.test(piece)) {
				fragment.append(piece)
				return
			}
			const word = document.createElement('span')
			word.className = 'fill-word'
			word.textContent = piece
			words.push(word)
			fragment.append(word)
		})
		node.replaceWith(fragment)
		return words
	})
}
